import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';

/** Bloque de carga con un brillo que lo recorre (sin brillo si se pidió menos movimiento). */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'relative isolate overflow-hidden rounded-lg bg-muted',
        'before:absolute before:inset-0 before:-translate-x-full before:animate-shimmer before:bg-linear-to-r before:from-transparent before:via-white/60 before:to-transparent motion-reduce:before:hidden dark:before:via-white/6',
        className,
      )}
      {...props}
    />
  );
}
